module.exports = __webpack_public_path__ + "static/media/streetview_icon.f2251e32.png";